

import { Fragment, useEffect, useState, } from "react";
import { Card, CardBody, CardHeader, Col, Container, Form,  FormGroup,  Label } from "reactstrap";

import Breadcrumb from "../../../components/common/breadcrumb";

import { Link, useNavigate, useParams } from "react-router-dom";

import { useForm } from "react-hook-form"

import axios from "../../../util/axiosInstance";


const CategoryEdit = () => {
    const navigate = useNavigate()

    const { id } = useParams();
    // const { data, isLoading, isError } = useGetSingleCategoryQuery({ id })
   
    const [data, setData] = useState({});
    

    useEffect(() => {
        axios.get(`/category/viewcategories/${id}`).then(res => setData(res.data))
    }, [])

    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    const onSubmit = (data) => {
        const updatedData = {
            ...data,
            status: 1
        }

        axios.put(`/category/editcategory/${id}`, updatedData)
            .then(res => {
                navigate('/product-management/CategoryList')
            })
    }

    return (
        <Fragment>
            <Breadcrumb title="Category List Edit" parent="Product Management" />
            <Container fluid={true}>
                <Card>
                    <CardHeader>
                        <div>
                            <h5 className="text-center"> Please Enter Valid Data</h5>
                        </div>
                    </CardHeader>
                    <CardBody>

                        <Form onSubmit={handleSubmit(onSubmit)}>

                            <FormGroup>
                                <Label for="exampleName">
                                    Category Name
                                </Label>
                                <input Value={data?.category_name} className="form-control"  {...register("category_name", { required: true })} />

                                {errors.category_name && <span className="text-danger">This field is required</span>}

                            </FormGroup>
                            <FormGroup row>
                                <Label
                                    for="exampleText"
                                >
                                    Description
                                </Label>
                                <Col>

                                    <textarea
                                        defaultValue={' '}
                                        {...register("description", { required: false })}
                                        type="textarea"
                                        className="form-control"
                                    />
                                </Col>
                                {errors.description && <span className="text-danger">This field is required</span>}
                            </FormGroup>
                            <div className="d-flex gap-5">
                                <input type="submit" value={'Update'} style={{ backgroundColor: 'green', border: 'none', padding: '12px 20px', color: 'white', borderRadius: '5px' }} />
                                <Link to={'/dashboard'} style={{ backgroundColor: 'red', textDecoration: 'none', border: 'none', padding: '12px 20px', color: 'white', borderRadius: '5px' }}> Close </Link>
                            </div>
                        </Form>

                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    );
};

export default CategoryEdit;
